import { CdkScrollable } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { RtAnalyticsModule } from '@recruitee/analytics';

import { RtUICommonModule } from '../common/common.module';
import { SidebarFilterComponent } from './sidebar-filter/sidebar-filter.component';
import { SidebarGroupComponent } from './sidebar-group/sidebar-group.component';
import { SidebarItemComponent } from './sidebar-item/sidebar-item.component';
import { SidebarLabelComponent } from './sidebar-label/sidebar-label.component';
import { SidebarComponent } from './sidebar/sidebar.component';

const COMPONENTS = [
  SidebarComponent,
  SidebarGroupComponent,
  SidebarItemComponent,
  SidebarLabelComponent,
  SidebarFilterComponent,
];

@NgModule({
  declarations: COMPONENTS,
  exports: COMPONENTS,
  imports: [RouterModule, RtUICommonModule, RtAnalyticsModule, CdkScrollable],
})
export class SidebarModule {}

export * from './interfaces';
export { SidebarService } from './sidebar.service';
export {
  SidebarComponent,
  SidebarGroupComponent,
  SidebarItemComponent,
  SidebarLabelComponent,
  SidebarFilterComponent,
};
